import store from '../store';
const ThemeUtil = {

  setTheme(theme) {
    window.document.documentElement.setAttribute('data-theme', theme)
    localStorage.setItem("theme", theme);
    store.dispatch('settings/changeSetting', {
      key: 'theme',
      value: theme
    })
  },
  getTheme() {
    return localStorage.getItem("theme")
  }
}
export default ThemeUtil;



// WEBPACK FOOTER //
// ./src/utils/ThemeUtil.js